import { Attachment } from '../../components/attachments/attachmentsModel'
import { LegacyReceiptData } from '../../domain/jobs/jobs'

/**
 * New receipts get a negative placeholder id. The api treats any id <= 0 as a
 * create and keys the items change-set by that same placeholder, so it has to
 * be unique within the posted receipts list.
 */
export const createNewReceipt = (jobId: number, receipts: LegacyReceiptData[], today: string): LegacyReceiptData => {
  const lowestId = Math.min(0, ...receipts.map(x => x.id))
  return {
    id: lowestId - 1,
    projectId: jobId,
    vendorId: 0,
    vendorName: '',
    receiptDate: today,
    receiptNumber: '',
    notes: '',
    owner: '',
    customTotal: null
  }
}

export const upsertReceipt = (
  receipts: LegacyReceiptData[],
  receipt: LegacyReceiptData
): LegacyReceiptData[] => {
  if (receipts.some(x => x.id === receipt.id)) {
    return receipts.map(x => x.id === receipt.id ? receipt : x)
  }
  return [...receipts, receipt]
}

export const toggleReceiptRemoved = (
  receipts: LegacyReceiptData[],
  receiptId: number
): LegacyReceiptData[] => {
  return receipts.map(x => x.id === receiptId ? { ...x, removed: !x.removed } : x)
}

export const isReceiptComplete = (receipt: LegacyReceiptData | undefined): boolean => {
  return !!receipt && !!receipt.vendorId && !!receipt.receiptNumber && !!receipt.receiptDate
}

export const receiptAttachmentFileName = (receipt: LegacyReceiptData): string => {
  return `${receipt.vendorName ?? ''} ${receipt.receiptNumber ?? ''}`.trim()
}

/** Legacy matched attachments in the job's folder whose name or tags mention the receipt number. */
export const filterReceiptAttachments = (
  attachments: Attachment[],
  jobFolder: string,
  receiptNumber: string
): Attachment[] => {
  if (!receiptNumber) {
    return []
  }
  return attachments
    .filter(attachment => attachment.folder === jobFolder)
    .filter(attachment => attachment.name?.includes(receiptNumber) || (attachment.tags ?? '').includes(receiptNumber))
}
